import api from '@/lib/api';
import { TemplateRequest, TemplateResponse } from '@/types/api';

export const templateService = {
  async getTemplates(): Promise<TemplateResponse[]> {
    const response = await api.get<TemplateResponse[]>('/templates');
    return response.data;
  },

  async getTemplate(id: string): Promise<TemplateResponse> {
    const response = await api.get<TemplateResponse>(`/templates/${id}`);
    return response.data;
  },

  async createTemplate(template: TemplateRequest): Promise<TemplateResponse> {
    const response = await api.post<TemplateResponse>('/templates', template);
    return response.data;
  },

  async updateTemplate(id: string, template: TemplateRequest): Promise<TemplateResponse> {
    const response = await api.put<TemplateResponse>(`/templates/${id}`, template);
    return response.data;
  },

  async deleteTemplate(id: string): Promise<void> {
    await api.delete(`/templates/${id}`);
  }
};